import React from 'react'
import { Box, IconButton } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import type { AttachedImage } from '../utils/imageAttachment'

interface ImagePreviewRowProps {
    images: AttachedImage[]
    onRemove: (id: string) => void
}

export const ImagePreviewRow: React.FC<ImagePreviewRowProps> = ({
    images,
    onRemove,
}) => {
    if (images.length === 0) return null

    return (
        <Box
            sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
                mb: 1,
                px: 0.5,
            }}
        >
            {images.map((img) => (
                <Box
                    key={img.id}
                    sx={{
                        position: 'relative',
                        width: 64,
                        height: 64,
                        borderRadius: 1,
                        overflow: 'hidden',
                        border: img.error
                            ? '1px solid var(--error-color, #ef4444)'
                            : '1px solid var(--card-border, #e2e8f0)',
                        background: 'var(--card-bg, #fff)',
                    }}
                >
                    {img.preview && !img.error ? (
                        <Box
                            component="img"
                            src={img.preview}
                            alt={img.file.name}
                            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: 9,
                                p: 0.5,
                                textAlign: 'center',
                                color: 'var(--error-color, #ef4444)',
                            }}
                        >
                            {img.error || 'Invalid'}
                        </Box>
                    )}
                    <IconButton
                        size="small"
                        aria-label={`Remove ${img.file.name}`}
                        onClick={() => onRemove(img.id)}
                        sx={{
                            position: 'absolute',
                            top: 2,
                            right: 2,
                            width: 20,
                            height: 20,
                            background: 'rgba(0,0,0,0.55)',
                            color: '#fff',
                            '&:hover': { background: 'rgba(0,0,0,0.75)' },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: 12 }} />
                    </IconButton>
                </Box>
            ))}
        </Box>
    )
}

export default ImagePreviewRow
